import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CommonConstants} from '@coreConstant';
import {ConfirmModalComponent} from '../components/confirm-modal/confirm-modal.component';

/**
 * Asks "Are you sure you want to log out of your account?" with Cancel / Logout, for every Logout
 * link (the header's profile menu and the account sidebar).
 *
 * @return true only when Logout is chosen. Cancel, Escape and a click outside the dialog all
 * resolve false and leave the customer signed in.
 */
export function askLogoutConfirmation(modalService: NgbModal): Promise<boolean> {
  const modalRef = modalService.open(ConfirmModalComponent, {centered: true});
  modalRef.componentInstance.title = CommonConstants.LOGOUT_CONFIRMATION_TITLE;
  modalRef.componentInstance.message = CommonConstants.LOGOUT_CONFIRMATION_MESSAGE;
  modalRef.componentInstance.confirmationButtonText = CommonConstants.LOGOUT_CONFIRMATION_BUTTON;
  return modalRef.result.then((result: unknown) => result === true, () => false);
}
